import { useRef } from 'react';

export const useDebounce = <T extends (...args: any[]) => void>(func: T, delay: number) => {
    const debounceTimeout = useRef<any>(null);

    return (...args: Parameters<T>) => {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            func(...args);
            debounceTimeout.current = null;
        }, delay);
    };
};
